/**
 * Display label for payee (driver) on adjustment cards.
 */

export const resolvePayeeNameFromOrder = (order, providerId) => {
  if (!providerId || !order) return null;
  const team = order?.booking?.assignedTeam;
  if (!team) return null;
  const id = String(providerId).trim();
  const primary = team.primaryDriver;
  if (primary?.driverId === id && primary?.name) {
    return String(primary.name).trim();
  }
  for (const d of team.drivers || []) {
    if (d?.driverId === id && d?.name) {
      return String(d.name).trim();
    }
  }
  return null;
};

export const getPayeeLabel = (adjustment, order = null) => {
  if (adjustment?.providerName) return adjustment.providerName;
  const fromOrder = resolvePayeeNameFromOrder(order, adjustment?.providerId);
  if (fromOrder) return fromOrder;
  return null;
};
